import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RegistrationService } from './services/registration.service'
import {CountriesService} from './services/countries.service';
import {StatesService} from './services/states.service';
import {Registration} from "./registration.interface";
import { _TRANSLATE } from '../shared/translation-marker';

declare var componentHandler: any;//needed to get js in materia.js to work with forms

@Component({
  //selector: 'app-registration-form',
  templateUrl: './registration-form.component.html',
  styleUrls: ['./registration-form.component.css']
})
export class RegistrationFormComponent implements OnInit {

  //user: User;
  //   registerForm: FormGroup;
    //username: AbstractControl;
    registerForm = <Registration>{
        'firstName': '',
        'lastName': '',
        'email': '',
        'organizationName': '',
        'organizationType': '',
        'title': '',
        'location': '',
        // 'city': '',
        'state': '',
        'plan': '',
        'termsOfUse': '',
        'emailOptOut': '',
        'url': '',
        'group': '',
        'username': '',
        'password': '',
        'confirmPassword': ''
    };

    usernameInUse: boolean;//hack var for form until I get asynch observable value to work (not sure why it was not working).
    emailInUse: boolean;
    urlInUse: boolean;
    error: boolean = false;
    errorMessage: string;
    states;
    locations;
    hideElement: boolean = false;
    hideElementUrl: boolean = false;
    isRequired:boolean=false;
    isUsernameTaken: boolean;
    returnUrl: string;
    statusMessage: object;
    disableSubmit = false;
    passwordsDoNotMatchMessage = { type: 'error', message: _TRANSLATE('Passwords do not match') };
    userNameUnavailableMessage = { type: 'error', message: _TRANSLATE('Username Unavailable') };
    userNameAvailableMessage = { type: 'success', message: _TRANSLATE('Username Available') };
    loginUnsucessfulMessage = { type: 'error', message: _TRANSLATE('Login Unsuccesful') };
    couldNotCreateUserMessage = { type: 'error', message: _TRANSLATE('Could Not Create User') };
    securityQuestionText: string;

    constructor(
        private _registrationService: RegistrationService,
        private _countriesService: CountriesService,
        private _statesService: StatesService,
        private _router: Router
    )  {
        this.statusMessage = { type: '', message: '' };
    }

    submitted = false;


    ngOnInit() {
        // console.log('hello again `RegistrationForm` component');
        this.getCounties();
        this.getStates();
        //this.username = this.registerForm.controls['username'];

    }

    register() {
        // const registerFormData = Object.assign({}, this.registerForm);

        // if (this.registerForm.dirty && this.registerForm.valid) {
        //alert(`First Name: ${this.registerForm.value.firstName} Email: ${this.registerForm.value.email}`);
        if (this.registerForm.url == '') this.registerForm.url = 'demo'
        if (this.registerForm.group == '') {
            var emailStr = this.registerForm.email
            var group = emailStr.replace(/\.|@|-|\!|#|\$|%|&|'|\+|-|\/|=|\?|\^|`|{|}|\||~|;/g, "_");
            this.registerForm.group = group;
        }
        // }

        this._registrationService.registerUser(this.registerForm)
            .subscribe(
                data => {
                    console.log(data);
                    this._router.navigate(['verify']);
                },//this.result = data,
                //WHEN TIME CAN ADD THIS BACK AS WE NO LONGER ARE CHAINING WE CAN GET THE ERROR MESSAGE AND PROVIDE TO USER: err => {this.error = JSON.parse(err._body); console.log(err); alert(JSON.stringify(err, null, 2)); console.log(JSON.stringify(err, null, 2))}, //let pJ = JSON.parse(err._body); alert(pJ.message);
                err => {
                    this.error = true;
                    let validationError = err.error.error;
                    if (typeof validationError !== 'undefined') {
                        let emailError = validationError.validationErrors["email"]
                        if (typeof emailError !== 'undefined') {
                            this.errorMessage = emailError[0];
                        }
                        console.log("this.errorMessage: " + this.errorMessage)
                    } else {
                        this.errorMessage = "There was an error; please check the logs."
                    }
                    alert("Error: " + this.errorMessage)

                    this.submitted = false;
                    console.log(err);
                    console.log(JSON.stringify(err, null, 2))
                },
                () => console.log('done')
            );
        this.submitted = true;
        //this._router.navigate(['Home']); //don't need injection for router as it is injected at root componenet (jw)
    }


    getCounties() {
        this._countriesService.getData().subscribe(
            data => { this.locations = data },
            err => console.error(err),
            () => console.log('done getting countries')
        );
    }
    getStates() {
        this._statesService.getData().subscribe(
            data => { this.states = data },
            err => console.error(err),
            () => console.log('done getting states')
        );
    }

    requireState(selectedValue) {
       if (selectedValue == "United States") {
            // this.registerForm.controls["state"].setValidators(Validators.required);
            // this.registerForm.controls["state"].setErrors( { 'stateRequired': true })
            this.hideElement = true;
       } else {
            // this.registerForm.controls["state"].setErrors(null)
            // this.registerForm.controls["state"].setValidators(null);
            this.hideElement = false;
       };
    }
    requireUrl(selectedValue) {
        if (selectedValue != "Free" && selectedValue != "") {
            // this.registerForm.controls["url"].setValidators(Validators.required);
            // this.registerForm.controls['url'].setErrors(
            //             { 'Url is required': true })
            this.hideElementUrl = true;
        } else {
            // this.registerForm.controls['url'].setErrors(null)
            // this.registerForm.controls["url"].setValidators(null);
            this.hideElementUrl = false;
        }
    };
    transformUsername(username) {
      // let username = this.registerForm.username;
      username = username.toLowerCase();
      username = username.replace(/[^a-z]/, '');
      this.registerForm.username = username;
      console.log("this.registerForm.username: " + this.registerForm.username)
    }

    emailExists(email) {        //make this cleaner when documentatoin on async validators come out, had to manually set control to invalid as nothing worked, and no documentation (jw note)
        //alert('protocol:' + window.location.protocol + 'host: ' + window.location.hostname)
        this._registrationService.emailCheck(email)
            .subscribe(
            data => {
                console.log(data);
                //alert(data.rows.length) is the same as below
                //alert(data["rows"].length);
                if (data['rows'].length) //empty array if nothing is found
                {
                    console.log("email found in db: ");
                    this.emailInUse = true;
                    // this.registerForm.controls['email'].setErrors(
                    //     { 'invalidEmailAsUsed': true })
                }
                else { this.emailInUse = false; }
            },// holds "value": "Username In Use" if taken
            err => console.log(err), //this.error = err, 
            () => console.log('done checking email')
            );
    }

    usernameExists(username) {        //make this cleaner when documentatoin on async validators come out, had to manually set control to invalid as nothing worked, and no documentation (jw note)
        //alert('protocol:' + window.location.protocol + 'host: ' + window.location.hostname)
        this._registrationService.usernameCheck(username)
            .subscribe(
            data => {
                console.log(data);
                //alert(data.rows.length) is the same as below
                //alert(data["rows"].length);
                if (data['rows'].length) //empty array if nothing is found
                {
                    console.log("username found in db: ");
                    this.usernameInUse = true;
                    // this.registerForm.controls['username'].setErrors(
                    //     { 'invalidUsernameAsUsed': true })
                }
                else { this.usernameInUse = false; }
            },// holds "value": "Username In Use" if taken
            err => console.log(err), //this.error = err, 
            () => console.log('done checking username')
            );
    }

    urlExists(url) {        //make this cleaner when documentatoin on async validators come out, had to manually set control to invalid as nothing worked, and no documentation (jw note)
        //alert('protocol:' + window.location.protocol + 'host: ' + window.location.hostname)
        this._registrationService.urlCheck(url)
            .subscribe(
            data => {
                console.log(data);
                if (data['rows'].length) //empty array if nothing is found
                {
                    console.log("urlExists found in db: ");
                    this.urlInUse = true;
                    // this.registerForm.controls['url'].setErrors(
                    //     { 'invalidUrlAsUsed': true })
                }
                else { this.urlInUse = false; }
            },
            err => console.log(err), //this.error = err, 
            () => console.log('done checking url')
            );
    }

    passwordsMatch() {
        if (this.registerForm.password == this.registerForm.confirmPassword) {
            //this.registerForm.controls['confirmPassword'].valid
        } else {
            // this.registerForm.controls['confirmPassword'].setErrors({ 'passwordsDontMatch': true });
        }
    }

    // get value(): string {
    //     return JSON.stringify(this.registerForm, null, 2);
    // }

    // Prevent native `submit` events from POSTing beause this crashes APKs.
    greaseTrap(event) {
        event.preventDefault()
    }


}
